import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = kg/s. */
export const MASS_FLOW_PIVOT: Record<string, number> = {
  'kg/s': 1,
  'lb/min': 0.00755987,
  'g/min': 1.66667e-5,
  'kg/min': 0.0166667,
  'kg/h': 0.000277778,
  't/h': 0.277778,
  'ton/h': 0.251996,
  'ton/d': 0.0104998,
  'lb/h': 0.000125998,
};

export const transformMassFlow = createPivotTransformer(MASS_FLOW_PIVOT);
